import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { PersonViewComponent } from './pages/person-view/person-view.component';
import { PersonEditComponent } from './pages/person-edit/person-edit.component';
import { LoginFailedComponent } from './pages/login-failed/login-failed.component';
import { PersonCreateComponent } from './pages/person-create/person-create.component';
import { PersonDetailsComponent } from './pages/person-details/person-details.component';

export const routes: Routes = [
  {
    path: 'person-create',
    component: PersonCreateComponent,
    canActivate: [
      MsalGuard
    ]
  },
  {
    path: 'person-edit/:id',
    component: PersonEditComponent,
    canActivate: [
      MsalGuard
    ]
  },
  {
    path: 'person-details/:id',
    component: PersonDetailsComponent,
    canActivate: [
      MsalGuard
    ]
  },
  {
    path: 'person-view',
    component: PersonViewComponent,
    canActivate: [
      MsalGuard
    ]
  },
  {
    // Needed for handling redirect after login
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'person-view'
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent
  }

];
